export default __webpack_public_path__ + "static/media/2_2_2ua.8252dfe6.png";